import { Checkbox, Input, InputNumber, Select, Tooltip } from "antd";
import { FilterFilled } from '@ant-design/icons';
import { Component } from "react";
import { Core } from "../infrastructure/core";
import { enmControlType, enmPropertyType, IProperty } from "./interfaces";
import { enmConditionalOperators } from "../infrastructure/filtering";
import { Lookup } from "../lookup";
import dayjs from 'dayjs';
import { DatePicker as DatePickerJalali } from "antd-jalali";
import { IBaseComponent } from "../infrastructure/baseComponent";
import './columnfilter.css';
const { Option } = Select;

export interface IColumnFilterState {
    conditionIsOpen: boolean;
    currentFilter: { operator: enmConditionalOperators; value?: any; };
}

export interface IColumnFilterProps {
    onChange?: (filter: { operator: enmConditionalOperators; value?: any; }) => void;
    property: IProperty;
    parent: IBaseComponent;
    initialValue?: { operator: enmConditionalOperators; value?: any; };
    preparelookupProps?: (lookupProps: any) => any;
    onLookupOpen?: () => void;
    onLookupClose?: (selectetEntity?: any) => void;
}

export class ColumnFilter extends Component<IColumnFilterProps, IColumnFilterState> {
    input?: Input | null;
    operators: any[] = [];
    constructor(props: IColumnFilterProps) {
        super(props)
        this.operators = Core.getOperators(this.props.property.propertyType!);
        this.state = {
            conditionIsOpen: false,
            currentFilter: props.initialValue ?? {
                operator: Number(this.operators[0].key),
                value: undefined
            }
        };
    }
    render() {
        let element: JSX.Element | null = null;
        if (this.props.property.controlType === enmControlType.textbox) {
            element = (
                <Input
                    id={this.props.property.dataIndex}
                    ref={node => this.input = node}
                    onChange={e => {
                        e.stopPropagation();
                        const currentFilter = { value: e.target.value, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    placeholder={this.props.property.title}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    type={"text"}
                    value={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.propertyType === enmPropertyType.boolean) {
            element = (
                <Checkbox
                    id={this.props.property.dataIndex}
                    onChange={e => {
                        const currentFilter = this.state.currentFilter.value === false && e.target.checked === true
                            ? { value: undefined, operator: this.state.currentFilter.operator }
                            : { value: e.target.checked, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    indeterminate={this.state.currentFilter.value === undefined}
                    checked={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.controlType === enmControlType.numberinput) {
            element = (
                <InputNumber
                    id={this.props.property.dataIndex}
                    onChange={e => {
                        const currentFilter = { value: e, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    placeholder={this.props.property.title}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    type={"number"}
                    value={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.controlType === enmControlType.password) {
            element = (
                <Input
                    id={this.props.property.dataIndex}
                    ref={node => this.input = node}
                    onChange={e => {
                        e.stopPropagation();
                        const currentFilter = { value: e.target.value, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    placeholder={this.props.property.title}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    type={"password"}
                    value={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.controlType === enmControlType.email) {
            element = (
                <Input
                    id={this.props.property.dataIndex}
                    ref={node => this.input = node}
                    onChange={e => {
                        e.stopPropagation();
                        const currentFilter = { value: e.target.value, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    placeholder={this.props.property.title}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    type={"email"}
                    value={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.controlType === enmControlType.lookup) {
            element = (
                <Lookup
                    parent={this.props.parent}
                    onChange={value => {
                        const currentFilter = { value, operator: this.state.currentFilter.operator }
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    isLookupMode={true}
                    property={this.props.property}
                    key={this.props.property.dataIndex}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    preparelookupProps={lookupProps => {
                        if (this.props.preparelookupProps)
                            return this.props.preparelookupProps(lookupProps);
                        return lookupProps;
                    }}
                    onLookupOpen={this.props.onLookupOpen}
                    onLookupClose={this.props.onLookupClose}
                    value={this.state.currentFilter.value}
                />);
        }
        else if (this.props.property.controlType === enmControlType.combobox) {
            let options: { value?: any; title?: string; }[] = [];
            if (this.props.property.combobox?.options)
                options = this.props.property.combobox.options;
            if (this.props.property.combobox?.optionsFunc)
                options = this.props.property.combobox.optionsFunc(this.props.parent, this.state.currentFilter.value);
            element = (
                <Select
                    id={this.props.property.dataIndex}
                    onChange={value => {
                        const currentFilter = { value, operator: this.state.currentFilter.operator };
                        this.setState({ currentFilter });
                        if (this.props.onChange)
                            this.props.onChange(currentFilter);
                    }}
                    placeholder={this.props.property.title}
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    allowClear
                    value={this.state.currentFilter.value}
                >
                    {options.map(o => <Option key={o.value} value={o.value}>{o.title}</Option>)}
                </Select>);
        }
        else if (this.props.property.controlType === enmControlType.date) {
            let currentValue = this.state.currentFilter.value;
            if (currentValue && !dayjs.isDayjs(currentValue))
                currentValue = dayjs(currentValue).calendar('jalali');
            element = (
                <DatePickerJalali
                    id={this.props.property.dataIndex}
                    key={this.props.property.dataIndex}
                    onChange={(value: any) => {
                        if (value) {
                            if (value.locale() === "fa") {
                                const date = dayjs(value.toDate()).locale('fa').format('YYYY-MM-DD');
                                const jalali = dayjs(date, { jalali: true } as any);
                                const miladi = jalali.locale('en').format('YYYY-MM-DD');
                                let parsedDate = new Date(miladi);
                                parsedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
                                const currentFilter = { value: parsedDate, operator: this.state.currentFilter.operator };
                                this.setState({ currentFilter });
                                if (this.props.onChange)
                                    this.props.onChange(currentFilter);
                            }
                            else {
                                let parsedDate = value.toDate();
                                parsedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
                                const currentFilter = { value: parsedDate, operator: this.state.currentFilter.operator };
                                this.setState({ currentFilter });
                                if (this.props.onChange)
                                    this.props.onChange(currentFilter);
                            }
                        }
                        else {
                            const currentFilter = { value: undefined, operator: this.state.currentFilter.operator };
                            this.setState({ currentFilter });
                            if (this.props.onChange)
                                this.props.onChange(currentFilter);
                        }
                    }}
                    placeholder={this.props.property.title}
                    format="YYYY/MM/DD"
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    value={currentValue}
                />);
        }
        else if (this.props.property.controlType === enmControlType.datetime) {
            let currentValue = this.state.currentFilter.value;
            if (currentValue && !dayjs.isDayjs(currentValue))
                currentValue = dayjs(currentValue).calendar('jalali');
            element = (
                <DatePickerJalali
                    id={this.props.property.dataIndex}
                    key={this.props.property.dataIndex}
                    onChange={(value: any) => {
                        if (value) {
                            if (value.locale() === "fa") {
                                const date = dayjs(value.toDate()).locale('fa').format('YYYY-MM-DD HH:mm');
                                const jalali = dayjs(date, { jalali: true } as any);
                                const miladi = jalali.locale('en').format('YYYY-MM-DD HH:mm');
                                let parsedDate = new Date(miladi);
                                parsedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
                                const currentFilter = { value: parsedDate, operator: this.state.currentFilter.operator };
                                this.setState({ currentFilter });
                                if (this.props.onChange)
                                    this.props.onChange(currentFilter);
                            }
                            else {
                                let parsedDate = value.toDate();
                                parsedDate = new Date(parsedDate.getTime());
                                const currentFilter = { value: parsedDate, operator: this.state.currentFilter.operator };
                                this.setState({ currentFilter });
                                if (this.props.onChange)
                                    this.props.onChange(currentFilter);
                            }
                        }
                        else {
                            const currentFilter = { value: undefined, operator: this.state.currentFilter.operator };
                            this.setState({ currentFilter });
                            if (this.props.onChange)
                                this.props.onChange(currentFilter);
                        }
                    }}
                    showTime={true}
                    placeholder={this.props.property.title}
                    format="YYYY/MM/DD hh:mm"
                    style={{ width: "calc(100% - 37px)", marginBottom: 8, display: 'inline-block' }}
                    value={currentValue}
                />);
        }

        const filterIconStyle = this.state.currentFilter.operator !== 0 ? { color: "#0093ff" } : {};

        return (
            <div key={this.props.property.dataIndex} >

                {element}

                {this.props.property.controlType !== enmControlType.checkbox &&
                    <Tooltip title="شرط">
                        <Select
                            aria-required={true}
                            onChange={(value: any) => {
                                let op: enmConditionalOperators = Number(value);
                                const currentFilter = { value: this.state.currentFilter.value, operator: op };
                                this.setState({ currentFilter });
                                if (this.props.onChange)
                                    this.props.onChange(currentFilter);
                            }}
                            dropdownMatchSelectWidth={false}
                            style={{ width: 20, marginRight: 6, marginBottom: 8, display: 'inline-block', direction: "ltr", position: "absolute" }}
                            suffixIcon={<FilterFilled style={filterIconStyle} onClick={() => this.setState({ conditionIsOpen: true })} />}
                            open={this.state.conditionIsOpen}
                            onDropdownVisibleChange={visible => this.setState({ conditionIsOpen: visible })}
                            placement="bottomLeft"
                            className="column-filter"
                            value={this.state.currentFilter.operator.toString()}

                        >
                            {this.operators.map(o => <Option key={o.key} value={o.key}>{o.value}</Option>)}
                        </Select>
                    </Tooltip>
                }
            </div>);
    }
}